// Modules
import React, { ReactNode } from 'react'
import Div100vh from 'react-div-100vh'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { Flex, Heading, Spacing, ThemeProvider } from '@dasa-health/alma-react'

// Components
import { LateralBannerLoginAuto } from 'redesign/components/molecules/LateralBannerLoginAuto'
import { ContainerContent } from './styles'
import { Header } from 'components/Header'

import { navTheme } from 'theme'
import { CustomSnackbar } from 'redesign/components/molecules/CustomSnackbar'
import { SnackbarProvider } from 'redesign/context/snackbar'
import { useCurrentLaboratory } from 'redesign/hooks/useCurrentLaboratory'

interface TemplateContainerProps {
    children: ReactNode
}

const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''

export const TemplateSelfService = ({ children }: TemplateContainerProps) => {
    const { title, currentLaboratory } = useCurrentLaboratory()
    return (
        <ThemeProvider theme={navTheme}>
            <SnackbarProvider>
                <Div100vh>
                    <Flex height="100%">
                        <LateralBannerLoginAuto />
                        <ContainerContent>
                            <Spacing height={32} />
                            <Flex maxWidth="448px" width="100%">
                                <Header logoAux={currentLaboratory} />
                            </Flex>
                            <Flex flexDirection="column" justifyContent="flex-start" marginTop="32px" maxWidth="448px" width="100%">
                                <Heading variant="md">{title}</Heading>
                                <Spacing height={16} />
                                <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey} useEnterprise>
                                    {children}
                                </GoogleReCaptchaProvider>
                            </Flex>
                        </ContainerContent>
                    </Flex>
                </Div100vh>
                <CustomSnackbar />
            </SnackbarProvider>
        </ThemeProvider>
    )
}
